// Import the necessary Firebase SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // For Firestore
import { getDatabase } from "firebase/database"; // For Realtime Database
import { getAuth } from "firebase/auth"; // For Authentication
import { getStorage } from "firebase/storage"; // For Storage
// import { getAnalytics } from "firebase/analytics"; // For Analytics (Optional)

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfI7kWOPhDFsg9P0yl8R-1eRwpeV6W77A",
  authDomain: "vivaak-5862d.firebaseapp.com",
  databaseURL: "https://vivaak-5862d-default-rtdb.firebaseio.com",
  projectId: "vivaak-5862d",
  storageBucket: "vivaak-5862d.firebasestorage.app",
  messagingSenderId: "851121485187",
  appId: "1:851121485187:web:3d20e0ae25e9709f8e72b6",
  measurementId: "G-PHZHBY54Q8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);
export { app, firestore, database, auth, storage };